import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { MasterService } from '../../../services/master.service';
import { StoreService } from '../../../services/store.service';
import * as words from '../../../services/language'

import { Stat } from 'src/app/models/stat.model';

@Component({
    selector: 'delinquency-chart',
    templateUrl: './delinquency-chart.component.html',
    styleUrls: ['./delinquency-chart.component.scss'],
    standalone: false
})
export class DelinquencyChartComponent implements OnInit, OnChanges {

    /** Threshold to determine if the delinquency percent is acceptable. */
    private DELINQUENCY_PERCENT_SUCCESS: number = 0.5

    /** Threshold to determine if the delinquency percent needs investigation. */
    private DELINQUENCY_PERCENT_WARNING: number = 0.1
    
    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // Word replacements for each language.
    @Input() words: Object = words.language

    /** */
    @Input() latest: Stat | null = null

    /** Options to send to the cahrt to determine how it will render. */
    protected options = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false,
                text: ''
            }
        }
    }

    /** The stat data to display on the chart. */
    protected stats = null;

    /** Percent of active accounts that are delinquent. */
    protected percent: number = 0
    
    // Indicates whether the data is currently loading.
    private loading: boolean = false

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }
        
        if (changes.latest) {
            this.construct()
        }
    }

    /**
     * Based on the latest stats construct the stat data for us in the chart.
     */
    private construct = () => {
        if (!this.latest) {
            return
        }

        const total = this.latest.delinquent1to15 + this.latest.delinquent16to30 + this.latest.delinquent31to60 +
                    this.latest.delinquent61to90 + this.latest.delinquent91AndOver

        this.percent = 0
        if (this.latest.accounts > 0) {
            this.percent = (total / this.latest.accounts)
        }

        this.stats = {
            labels: ['1 to 15', '16 to 30', '31 to 60', '61 to 90', '91 and over'],
            datasets: [{
                axis: 'y',
                label: null,
                data: [
                    this.latest.delinquent1to15,
                    this.latest.delinquent16to30,
                    this.latest.delinquent31to60,
                    this.latest.delinquent61to90,
                    this.latest.delinquent91AndOver
                ],
                backgroundColor: [
                    'rgba(220, 53, 69, 0.2)',
                    'rgba(220, 53, 69, 0.4)',
                    'rgba(220, 53, 69, 0.6)',
                    'rgba(220, 53, 69, 0.8)',
                    'rgba(220, 53, 69, 1)'
                ],
                borderColor: [
                    'rgba(220, 53, 69, 0.0)',
                    'rgba(220, 53, 69, 0.2)',
                    'rgba(220, 53, 69, 0.4)',
                    'rgba(220, 53, 69, 0.6)',
                    'rgba(220, 53, 69, 0.8)'
                ],
                borderWidth: 1
            }]
        }
    }

    /**
     * Based on the current delinquency percent return a 
     * badge color to use for the percent display.
     */
    protected level = (): string => {
        if (!this.percent) {
            return 'secondary'
        }

        if (this.percent <= this.DELINQUENCY_PERCENT_SUCCESS) {
            return 'success'
        }

        if (this.percent <= this.DELINQUENCY_PERCENT_WARNING) {
            return 'warning'
        }

        return 'danger'
    }
}
